var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './Dropdown.styles.scss';
var Dropdown = function (_a) {
    var children = _a.children, containerRef = _a.containerRef, dropdownPosition = _a.dropdownPosition, inputRef = _a.inputRef;
    var getDropDownPositionStyles = function () {
        var _a, _b, _c;
        if (dropdownPosition === 'bottom') {
            return {
                width: (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width,
            };
        }
        else {
            return {
                width: (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width,
                bottom: Number((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.clientHeight),
            };
        }
    };
    var _b = useState(getDropDownPositionStyles), dropDownPositionStyles = _b[0], setDropDownPositionStyles = _b[1];
    useEffect(function () {
        if (!containerRef.current)
            return;
        var resizeObserver = new ResizeObserver(function () {
            setDropDownPositionStyles(getDropDownPositionStyles());
        });
        resizeObserver.observe(containerRef.current);
        return function () {
            resizeObserver.disconnect();
        };
    }, []);
    return (_jsx("div", __assign({ className: "hefesto-dropdown hefesto-dropdown--".concat(dropdownPosition), style: dropDownPositionStyles, "data-testid": "hefesto-dropdown" }, { children: children })));
};
export default Dropdown;
